const initialState = {
  entries: [],
  isLoading: false,
  isLoaded: false,
  error: null,
}

export default function garage(state = initialState, action) {
  const { type, payload } = action

  switch (type) {
    case "FETCH_GARAGE_START":
      return { ...state, isLoading: true, error: null }
    case "FETCH_GARAGE_SUCCESS":
      return { ...state, isLoading: false, entries: payload, isLoaded: true }
    case "FETCH_GARAGE_ERROR":
      return { ...state, isLoading: false, error: payload }

    case "ADD_TO_GARAGE_START":
      return { ...state, isLoading: true, error: null }
    case "ADD_TO_GARAGE_SUCCESS":
      return { ...state, isLoading: false, entries: payload }
    case "ADD_TO_GARAGE_ERROR":
      return { ...state, isLoading: false, error: payload }

    case "REMOVE_FROM_GARAGE_START":
      return { ...state, isLoading: true, error: null }
    case "REMOVE_FROM_GARAGE_SUCCESS":
      return { ...state, isLoading: false, entries: payload }
    case "REMOVE_FROM_GARAGE_ERROR":
      return { ...state, isLoading: false, error: payload }

    case "SEND_SMS_START":
    case "LOGOUT_SUCCESS":
      return initialState

    default:
      return state
  }
}
